import autoBind      from 'react-autobind';
import React         from 'react';
import { PropTypes } from 'prop-types';

import Select from '~/components/forms/select';

class JobPositionSelect extends React.Component {
  constructor(props) {
    super(props);

    const options = [
      { value: 'Director',        label: 'Director' },
      { value: 'GM',              label: 'GM' },
      { value: 'VP',              label: 'VP' },
      { value: 'CEO',             label: 'CEO' },
      { value: 'CFO',             label: 'CFO' },
      { value: 'General Counsel', label: 'General Counsel' },
      { value: 'Other',           label: 'Other' },
    ];

    this.state = {
      options,
    };

    autoBind(this);
  }

  render() {
    const { options } = this.state;
    const { value } = this.props;

    return (
      <Select
        {...this.props}
        value={value}
        onChange={this.props.onChange}
        options={options}
      />
    );
  }
}

JobPositionSelect.defaultProps = {
  onChange: () => {},
  value:    '',
};

JobPositionSelect.propTypes = {
  onChange: PropTypes.func,
  value:    PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
};

export default JobPositionSelect;
